
export default {
    created: function () {
        this.pageTitle && this.$Meta.setTitle(this.pageTitle);
        this.pageDescription && this.$Meta.setDescription(this.pageDescription);
    },
    watch: {
        pageTitle(to){
            this.$Meta.setTitle(to)
        },
        pageDescription(to){
            this.$Meta.setDescription(to)
        }
    }
}